import { render, staticRenderFns } from "./eligibility-result.vue?vue&type=template&id=cc065386"
import script from "./eligibility-result.vue?vue&type=script&lang=js"
export * from "./eligibility-result.vue?vue&type=script&lang=js"
import style0 from "./eligibility-result.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PatternsCtaText: require('/home/node/app/components/patterns/cta-text/cta-text.vue').default,ElementsDumbImg: require('/home/node/app/components/elements/dumb-img/dumb-img.vue').default,PatternsFormCheck: require('/home/node/app/components/patterns/form-check/form-check.vue').default,PatternsFormInput: require('/home/node/app/components/patterns/form-input/form-input.vue').default,PatternsUiCta: require('/home/node/app/components/patterns/ui-cta/ui-cta.vue').default})
